import State from "./models/State"
import { ObservableFromFetch } from "./ObservableFromFetch"

export const getStates = () => ObservableFromFetch<State[]>(`State`)
